'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('clinic-setup', {
    url: '/clinic/:id/setup/:step/',
    templateUrl: '/views/clinic-setup.html',
    controller: 'ClinicSetupCtrl',
    data: {
      wizardView: true,
    },
    resolve: {
      auth: authorizationProvider.requireAuthorizedUser,
      clinic: function($stateParams, ClinicService) {
        return ClinicService.getClinic($stateParams.id);
      },
      pageTitle: function($pageTitle, clinic) {
        $pageTitle.set('Setup - ' + clinic.name + ' - Opencare');
      },
      questions: function(QuestionService) {
        return QuestionService.listClinicQuestions();
      },
    },
  });

  $stateProvider.state('clinic-create', {
    url: '/clinic/create/',
    templateUrl: '/views/clinic-setup.html',
    controller: 'ClinicSetupCtrl',
    data: {
      wizardView: true,
    },
    resolve: {
      auth: authorizationProvider.requireAuthorizedUser,
      clinic: function() {
        return {
          id: 'new',
          phone: '',
          hours: [{
            start: 0,
            end: 0,
          }, {
            start: 0,
            end: 0,
          }, {
            start: 0,
            end: 0,
          }, {
            start: 0,
            end: 0,
          }, {
            start: 0,
            end: 0,
          }, {
            start: 0,
            end: 0,
          }, {
            start: 0,
            end: 0,
          }],
          latitude: 0,
          longitude: 0,
          address: {},
          addressDetails: {},
        };
      },
      pageTitle: function($pageTitle) {
        $pageTitle.set('New Clinic - Opencare');
      },
      questions: function(QuestionService) {
        return QuestionService.listClinicQuestions();
      },
    },
  });
});

angular.module('ClinicApp').controller('ClinicSetupCtrl', function(
  $scope,
  $state,
  $stateParams,
  $filter,
  $window,
  $document,
  $location,
  $q,
  $timeout,
  clinic,
  questions,
  CurrentUser,
  ClinicService,
  OCAddressUtil,
  OCValidationUtil,
  OCMapUtil,
  OCWizardUtil,
  OCModalUtil,
  OCHoursUtil,
  OCClinicUtil,
  WizardHandler,
  GrowlService,
  QuestionService,
  PhoneUtils,
) {
  var map = null;
  var marker = null;
  $scope.hoursEditMode = true;
  $scope.isValidPhoneNumber = OCValidationUtil.isValidPhoneNumber;
  $scope.isValidWebsite = OCValidationUtil.isValidWebsite;

  var initialStep = parseInt($stateParams.step || 1, 10);
  OCWizardUtil.setStep($scope, initialStep);

  $scope.clinic = clinic;
  $scope.clinic.phoneNumber = $filter('phone')(clinic.phone.split('x')[0]);
  $scope.clinic.addressString = OCAddressUtil.addressAsString($scope.clinic.address);

  $scope.questions = questions;
  // Populate questions with clinic responses.
  angular.forEach($scope.questions, function(question) {
    var response = _.find($scope.clinic.questionResponses, function(_response) {
      return _response.question.id == question.id;
    });
    var text = response ? response.response : null;
    // Keep actual and origin response text to avoid extra saves when response is not changed.
    question.response = {
      text: text,
      origin: text,
    };
    question.showExample = false;
  });

  $scope.errors = {};

  $scope.$watch('clinic.addressDetails', function() {
    $scope.errors.address = null;
    if ($scope.clinic.addressDetails && !OCAddressUtil.map.checkPlace($scope.clinic.addressDetails)) {
      $scope.errors.address = 'Please select a street address from the dropdown.';
      return;
    }
    if ($scope.clinic.addressDetails && $scope.clinic.addressDetails.geometry) {
      $timeout(function() {
        google.maps.event.trigger(map, 'resize');
        var location = $scope.clinic.addressDetails.geometry.location;
        OCMapUtil.setMapMarkerPosition(map, marker, location.lat(), location.lng());
      }, 100);
    }
  }, true);

  $window.onresize = function() {
    if (marker) {
      OCMapUtil.setMapMarkerPosition(map, marker, marker.getPosition().lat(), marker.getPosition().lng());
    }
  };

  $scope.isNewClinic = function() {
    return clinic.id == 'new';
  };

  $scope.hideMap = function() {
    return $scope.isNewClinic() && (!clinic.addressDetails || !Object.keys(clinic.addressDetails).length);
  };

  $scope.phoneVerified = function() {
    var phone = PhoneUtils.formatPhoneNumber($scope.clinic.phoneNumber);
    return $scope.clinic.phone.split('x')[0] == phone && $scope.clinic.phoneVerified;
  };

  $scope.nextStep = function() {
    var step = parseInt($stateParams.step, 10) + 1;
    $state.go($state.current.name, {
      step: step,
    });
  };

  // Due to the nature of the wizard construction, the map canvas is not available
  // until the wizard DOM constructs.
  $scope.$watch(function() {
    return WizardHandler.wizard();
  }, function() {
    if (!map) {
      map = OCMapUtil.newMap($document.find('#js-clinic-map')[0], $scope.clinic.latitude, $scope.clinic.longitude);
      marker = OCMapUtil.addMarker(map, $scope.clinic.latitude, $scope.clinic.longitude);
    }

    // Disable appearing of the title tooltip that is added automatically by the wizard.
    $document.find('section.step').each(function() {
      this.title = '';
    });
  });

  function verifyPhone() {
    return OCModalUtil.showModal(
      'clinicPhoneVerify',
      {
        clinic: $scope.clinic,
        modalType: 'UPDATE',
      },
    ).then(function(code) {
      if (code) {
        return ClinicService.verifyPhone($scope.clinic.id, code);
      }
    });
  }

  $scope.saveBasicInfo = function(form) {
    if (form.$invalid) {
      return $q.reject();
    }

    if ($scope.isNewClinic()) {
      return ClinicService.findWithPhone(PhoneUtils.formatPhoneNumber($scope.clinic.phoneNumber))
        .then(function(clinics) {
        // Find already claimed clinics with the given phone number that doesn't belong to the user company.
          var claimedClinics = _.filter(clinics, function(clinic) {
            return clinic.claimedAt && clinic.company && clinic.company.id != _.get(CurrentUser, 'getCompany().id');
          });
          if (claimedClinics.length) {
            GrowlService.error('A clinic with this phone number already exists and belongs to another company. Please contact support if you believe this is an error: <a href="mailto:prime@opencare.com">prime@opencare.com</a>');
            return $q.reject();
          }

          // Select unclaimed clinics with the given phone number.
          var unclaimedClinics = _.filter(clinics, function(clinic) {
            return !clinic.claimedAt;
          });
          if (unclaimedClinics.length) {
          // Propose to claim already existing clinic with the same phone number.
            var unclaimedClinic = unclaimedClinics[0];
            return OCModalUtil.showCustomModal({
              templateUrl: '/views/modals/_claim-existing-confirm.html',
              controller: 'ModalGenericYesNo',
              resolve: OCModalUtil.createResolve({
                content: unclaimedClinic,
              }),
            })
              .then(() => {
                return OCModalUtil.showModal(
                  'clinicPhoneVerify',
                  {
                    clinic: unclaimedClinic,
                    modalType: 'CLAIM',
                  },
                );
              })
              .then((code) => {
                OCClinicUtil.claimClinic(unclaimedClinic.id, code);
              })
              .then(() => {
                return ClinicService.updateClinic(unclaimedClinic, {
                  name: $scope.clinic.name,
                  website: $scope.clinic.website,
                });
              })
              .then(() => {
                // Continue with just claimed clinic.
                $location.path('/clinic/' + unclaimedClinic.id + '/setup/1/').replace();
              })
              .catch(() => {
                // Otherwise, continue creating new clinic.
                WizardHandler.wizard().next();
              });
          }

          WizardHandler.wizard().next();
        });
    }

    $scope.clinic.website = OCValidationUtil.urlFormat($scope.clinic.website);
    return updateClinic({
      name: $scope.clinic.name,
      phone: PhoneUtils.formatPhoneNumber($scope.clinic.phoneNumber),
      website: $scope.clinic.website,
    }).then(function(clinic) {
      // Clinic name may have been updated, update nav.
      CurrentUser.update();

      $scope.clinic.phone = clinic.phone;
      $scope.clinic.phoneVerified = clinic.phoneVerified;

      if (!clinic.phoneVerified) {
        return verifyPhone();
      }
    })
      .then(function() {
        $scope.nextStep();
      });
  };

  $scope.saveLocation = function(form) {
    if (form.$invalid || $scope.errors.address) {
      return $q.reject();
    }

    var location = OCAddressUtil.map.parsePlace($scope.clinic.addressDetails);
    if (location) {
      location.address.suite = $scope.clinic.address.suite;
      angular.extend($scope.clinic, location);
    }

    if ($scope.clinic.id == 'new') {
      var clinicCreated = false;
      return ClinicService.createClinic(CurrentUser.getCompany().id, {
        name: $scope.clinic.name,
        phone: PhoneUtils.formatPhoneNumber($scope.clinic.phoneNumber),
        website: $scope.clinic.website,
        address: $scope.clinic.address,
        latitude: $scope.clinic.latitude,
        longitude: $scope.clinic.longitude,
      })
        .then((clinic) => {
          clinicCreated = true;
          $scope.clinic = clinic;
          $scope.clinic.addressString = OCAddressUtil.addressAsString($scope.clinic.address);
          if (!$scope.clinic.phoneVerified) {
            return verifyPhone();
          }
        })
        .finally(() => {
          if (clinicCreated) {
            CurrentUser.update();
            // Replace /clinic/create/ in the path with step 1, so the back button
            // works as expected, then redirect to step 2, then to step 3.
            $location.path('/clinic/' + $scope.clinic.id + '/setup/1/').replace();
            $timeout(function() {
              $location.path('/clinic/' + $scope.clinic.id + '/setup/2/');
              $timeout(function() {
                $location.path('/clinic/' + $scope.clinic.id + '/setup/3/');
              });
            });
          }
        });
    }

    return updateClinic({
      address: $scope.clinic.address,
      latitude: $scope.clinic.latitude,
      longitude: $scope.clinic.longitude,
    }).then(function() {
      $scope.nextStep();
    });
  };

  $scope.hasInvalidDay = function() {
    return OCHoursUtil.hasInvalidDay($scope.clinic.hours);
  };

  $scope.saveHours = function() {
    return updateClinic({
      hours: $scope.clinic.hours,
    }).then(function() {
      $scope.nextStep();
    });
  };

  $scope.saveQuestionResponse = function(question, refreshDiscoverabilityScore) {
    if (question.response.text == question.response.origin) {
      return $q.when();
    }
    return QuestionService.respond(
      question.id,
      question.modelType,
      $scope.clinic.id,
      question.response.text || null,
    ).then(function() {
      question.response.origin = question.response.text;
      return refreshDiscoverabilityScore ? ClinicService.getClinic($scope.clinic.id) : null;
    });
  };

  $scope.saveQuestionResponses = function() {
    var saves = [];
    angular.forEach($scope.questions, function(question) {
      saves.push($scope.saveQuestionResponse(question));
    });

    return $q.all(saves).then(function() {
      $scope.finish();
    });
  };

  $scope.finish = function() {
    $state.go('clinic', {
      id: $stateParams.id,
    });
  };

  function updateClinic(data) {
    return ClinicService.updateClinic($scope.clinic, data);
  }

});
